import { useEffect, useState } from "react";
import { Socket } from "socket.io-client";

import { SocketNamespace } from "@/interfaces/globals";
import { getSocketManager } from "@/redux/slices/configSlice";
import { useAppSelector } from "@/redux/store";

interface UseSocketReturnType {
  socket: Socket | null;
  isConnected: boolean;
}

export const useSocket = (nameSpace: SocketNamespace): UseSocketReturnType => {
  const token = useAppSelector((state) => state.user.userToken);
  const socketManagerRevision = useAppSelector(
    (state) => state.config.socketManagerRevision,
  );
  const workspace =
    useAppSelector((state) => state.user.workspaceData?.id) || "";
  const [socket, setSocket] = useState<Socket | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const manager = getSocketManager();

    if (!token || !manager) {
      return undefined;
    }

    const nextSocket = manager.socket(nameSpace, {
      ...(token && {
        auth: {
          token: `Bearer ${token}`,
        },
      }),
    });

    const onConnect = (): void => {
      setIsConnected(true);
    };

    const onDisconnect = (): void => {
      setIsConnected(false);
    };

    nextSocket.on("connect", onConnect);
    nextSocket.on("disconnect", onDisconnect);
    setSocket(nextSocket);
    setIsConnected(nextSocket.connected);

    return (): void => {
      nextSocket.off("connect", onConnect);
      nextSocket.off("disconnect", onDisconnect);
      setSocket(null);
      setIsConnected(false);
    };
  }, [token, socketManagerRevision, nameSpace, workspace]);

  return { socket, isConnected };
};
